import React, {useState} from 'react';
import './style.css';
import { ToggleBar } from '../../components/toggleBar/toggleBar';
import CampaignSelector from '../../components/toggleBar/toggleBarOptions';
import { DashboardWidget } from '../../components/dashboardWidget/dashboardWidget';
import FlowType from '../../components/dashboardWidget/flowType';
import ContentHeading from '../../components/contentHeading/contentHeading';




const Dashboard = ({metricData, showMetrics}) => {
    return (
        <div className='dashboard-container'>
            
            <ContentHeading heading={"Dashboards"}/>

            <DashboardWidget flowType={FlowType.Performance}/>
            <DashboardWidget flowType={FlowType.Conversion}/>
            <DashboardWidget flowType={FlowType.Campaign}/>
        </div>
    );
};

export { Dashboard };
